import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEmailTagSource implements BaseEnumType {
  private static allValues: EnumEmailTagSource[] = []; // make sure this is top-most
  
  public static none = new EnumEmailTagSource(0, "None", "enum_email_tag_source_none");
  public static enumDocumentEmailTag = new EnumEmailTagSource(1, "EnumDocumentEmailTag", "enum_email_tag_source_enum_document_email_tag");
  public static documentTag = new EnumEmailTagSource(2, "DocumentTag", "enum_email_tag_source_document_tag");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEmailTagSource.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumEmailTagSource.none; }
  public isEnumDocumentEmailTag() { return this === EnumEmailTagSource.enumDocumentEmailTag; }
  public isDocumentTag() { return this === EnumEmailTagSource.documentTag; }

  public static getValues(): readonly EnumEmailTagSource[] {
    return EnumEmailTagSource.allValues;
  }

  public static getValuesExcept0(): readonly EnumEmailTagSource[] {
    return EnumEmailTagSource.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEmailTagSource {
    const found = EnumEmailTagSource.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEmailTagSource - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEmailTagSource): EnumEmailTagSource {
    const found = name ? EnumEmailTagSource.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEmailTagSource - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEmailTagSource>): boolean {
    return this.key === other?.key;
  }
}